import { IconButton } from '@civilgrid/ui/components';
import { nanoid } from 'nanoid';
import { useMemo, useState } from 'react';
import { useSnapshot } from 'valtio';
import { constructFile } from '~/common/miscUtils';
import { FileCategory } from '~/common/types';
import UploadButton from '~/components2/forms/UploadButton';
import store from '../../../../store';

export default function FilesComponent() {
  const [isProcessing, setIsProcessing] = useState(false);
  const { formState } = useSnapshot(store);

  const onUpload = (files: File[]) => {
    setIsProcessing(true);

    files.forEach((f) => {
      const file = constructFile(f, { category: FileCategory.SupportingFile });
      store.formState.files[nanoid()] = file;
    });

    setIsProcessing(false);
  };

  const files = useMemo(() => {
    return Object.keys(formState.files).map((id) => {
      const f = formState.files[id];
      const name = f.get('name')?.toString() || 'UNNAMED FILE';

      return (
        <div key={`dr-file-${id}`} className="flex w-full items-center justify-between border-b hover:bg-brand-light">
          <div>{name}</div>

          <IconButton
            variant="hollow"
            icon="trash"
            aria-label={`Remove file ${name}`}
            onClick={() => {
              delete store.formState.files[id];
            }}
          />
        </div>
      );
    });
  }, [formState.files]);

  return (
    <div className="my-8 space-y-2">
      <div className="text-base font-semibold">Completed Documents</div>
      <div>Upload completed documents</div>
      <UploadButton isProcessing={isProcessing} disabled={isProcessing} onUpload={onUpload} multiple>
        Upload Files
      </UploadButton>

      <div className="flex w-full flex-col">{files}</div>
    </div>
  );
}
